import React from "react";

import ChatGptIcon from "@common/assets/images/ai/chatgpt.png";
import ClaudeIcon from "@common/assets/images/ai/claude.png";
import GeminiIcon from "@common/assets/images/ai/gemini.png";
import GrokIon from "@common/assets/images/ai/grok.png";
import PerplexityIcon from "@common/assets/images/ai/perplexity.png";
import Tooltip from "@common/components/Tooltip/Tooltip";
import * as Styled from "@main/pages/shared/components/SheldonSummary/AiAssistantButton/AiAssistantButton.styles";

interface AiAssistantButtonProps {
  aiAssistant: AiAssistant;
  tooltip: string;
  onClick: () => void;
  disabled?: boolean;
}

export const AiAssistantButton = ({ aiAssistant, onClick, tooltip, disabled }: AiAssistantButtonProps) => {
  return (
    <Styled.AiAssistantButton
      onClick={onClick}
      disabled={disabled}
    >
      <Tooltip
        position={"top"}
        style={{ width: "auto" }}
        text={tooltip}
      >
        <img
          src={aiAssistant.icon}
          alt={aiAssistant.name}
        />
      </Tooltip>
    </Styled.AiAssistantButton>
  );
};

export interface AiAssistant {
  name: string;
  icon: string;
  url: string;
}

export const aiAssistants: AiAssistant[] = [
  {
    name: "ChatGPT",
    icon: ChatGptIcon,
    url: "https://chatgpt.com/?prompt=",
  },
  {
    name: "Claude",
    icon: ClaudeIcon,
    url: "https://claude.ai/new?q=",
  },
  {
    name: "Gemini",
    icon: GeminiIcon,
    url: "https://www.google.com/search?udm=50&aep=11&q=",
  },
  {
    name: "Perplexity",
    icon: PerplexityIcon,
    url: "https://www.perplexity.ai/search/new?q=",
  },
  {
    name: "Grok",
    icon: GrokIon,
    url: "https://grok.com?q=",
  },
];
